/**
 * Module dependencies.
 */

import colorUtil from 'color';
import { colors } from 'src/styles/colors';

/**
 * Export `transparentize`.
 */

export function transparentize(colorName: keyof typeof colors, opacity: number): string {
  return colorUtil(colors[colorName]).alpha(opacity).rgb().string();
}
